export default "__VITE_ASSET__DpDb25kT__"